module.exports = __webpack_public_path__ + "img/volcano.7fd45471.jpg";